import Api from '@/services/Api';

export default {
  search(queryString) {
    let config = {
      params: {
        query: queryString
      }
    };
    return Api().get('/location/search', config);
  },
  revGeocode(lng, lat) {
    return Api().get('/location/reversegeocode/' + lng + '/' + lat);
  },
  convertXlsx2Geojson(fileData) {
    return Api().post('/convert', fileData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  exportGeojsonSample() {
    return Api().get('/sample/geojson');
  },
  exportXlsxSample() {
    let config = {
      responseType: 'arraybuffer'
    };
    return Api().get('/sample/xlsx', config);
  }
};
